    
    
    export const JoystickUtils = {
      hide: () =>null,
      reveal: () => null ,
    }


    export const VirtualJoystick = (scene, camera, canvas) => {
    let adt = BABYLON.GUI.AdvancedDynamicTexture.CreateFullscreenUI("UI");
    
    // ADJUST PUCK SIZE HERE 
    let puckSize = adt._canvas.height * 0.3; 
    if (puckSize < 130) puckSize = 130; 
    
    let xAddPos = 0;
    let yAddPos = 0;
    let xAddRot = 0;
    let yAddRot = 0;
    let sideJoystickOffset = 15;
    let bottomJoystickOffset = -20;
    let translateTransform;
    console.log(adt._canvas.height)
    let leftThumbContainer = makeThumbArea("leftThumb", 0, "", null, null, window.pakopeliPublicAssetUrl + "navi_move.png", "leftThumbContainer");
    leftThumbContainer.height = puckSize + "px";
    leftThumbContainer.width = puckSize + "px";
    leftThumbContainer.isPointerBlocker = true;
    leftThumbContainer.horizontalAlignment =
      BABYLON.GUI.Control.HORIZONTAL_ALIGNMENT_LEFT;
    leftThumbContainer.verticalAlignment =
      BABYLON.GUI.Control.VERTICAL_ALIGNMENT_BOTTOM;
    leftThumbContainer.alpha = 0.5;
    leftThumbContainer.left = sideJoystickOffset;
    leftThumbContainer.top = bottomJoystickOffset;

    let leftInnerThumbContainer = makeThumbArea(
      "leftInnterThumb",
      1,
      "blue",
      "#00f8ff"
    );
    leftInnerThumbContainer.height = "20%";
    leftInnerThumbContainer.width = "20%";
    leftInnerThumbContainer.isPointerBlocker = true;
    leftInnerThumbContainer.horizontalAlignment =
      BABYLON.GUI.Control.HORIZONTAL_ALIGNMENT_CENTER;
    leftInnerThumbContainer.verticalAlignment =
      BABYLON.GUI.Control.VERTICAL_ALIGNMENT_CENTER;

    let leftPuck = makeThumbArea("leftPuck", 0, "blue", "blue", null, window.pakopeliPublicAssetUrl + "navi_move.png");
    leftPuck.height = "10%";
    leftPuck.width = "10%";
    leftPuck.isPointerBlocker = true;
    leftPuck.horizontalAlignment =
      BABYLON.GUI.Control.HORIZONTAL_ALIGNMENT_CENTER;
    leftPuck.verticalAlignment = BABYLON.GUI.Control.VERTICAL_ALIGNMENT_CENTER;

    leftThumbContainer.onPointerDownObservable.add(function (coordinates) {
      leftPuck.isVisible = true;
      leftPuck.floatLeft =
        coordinates.x -
        leftThumbContainer._currentMeasure.width * 0.5 -
        sideJoystickOffset;
      leftPuck.left = leftPuck.floatLeft;
      leftPuck.floatTop =
        adt._canvas.height -
        coordinates.y -
        leftThumbContainer._currentMeasure.height * 0.5 +
        bottomJoystickOffset;
      leftPuck.top = leftPuck.floatTop * -1;
      leftPuck.isDown = true;
      leftThumbContainer.alpha = 0.3;
    });

    leftThumbContainer.onPointerUpObservable.add(function (coordinates) {
      xAddPos = 0;
      yAddPos = 0;
      leftPuck.isDown = false;
      leftPuck.isVisible = false;
      leftThumbContainer.alpha = 0.2;
    });

    leftThumbContainer.onPointerMoveObservable.add(function (coordinates) {
      if (leftPuck.isDown) {
        xAddPos =
          coordinates.x -
          leftThumbContainer._currentMeasure.width * 0.5 -
          sideJoystickOffset;
        yAddPos =
          adt._canvas.height -
          coordinates.y -
          leftThumbContainer._currentMeasure.height * 0.5 +
          bottomJoystickOffset;
        leftPuck.floatLeft = xAddPos;
        leftPuck.floatTop = yAddPos * -1;
        leftPuck.left = leftPuck.floatLeft;
        leftPuck.top = leftPuck.floatTop;
      }
    });

    adt.addControl(leftThumbContainer);
    leftThumbContainer.addControl(leftInnerThumbContainer);
    leftThumbContainer.addControl(leftPuck);
    leftPuck.isVisible = false;

    let rightThumbContainer = makeThumbArea("rightThumb", 0, "red", null, null, window.pakopeliPublicAssetUrl + "navi_rotate.png", "rightThumbContainer");
    rightThumbContainer.height = puckSize + "px";
    rightThumbContainer.width = puckSize + "px";
    rightThumbContainer.isPointerBlocker = true;
    rightThumbContainer.horizontalAlignment =
      BABYLON.GUI.Control.HORIZONTAL_ALIGNMENT_RIGHT;
    rightThumbContainer.verticalAlignment =
      BABYLON.GUI.Control.VERTICAL_ALIGNMENT_BOTTOM;
    rightThumbContainer.alpha = 0.5;
    rightThumbContainer.left = -sideJoystickOffset;
    rightThumbContainer.top = bottomJoystickOffset;

    let rightInnerThumbContainer = makeThumbArea(
      "rightInnterThumb",
      0,
      "red",
      "#ff23d1"
    );
    rightInnerThumbContainer.height = "20%";
    rightInnerThumbContainer.width = "20%";
    rightInnerThumbContainer.isPointerBlocker = true;
    rightInnerThumbContainer.horizontalAlignment =
      BABYLON.GUI.Control.HORIZONTAL_ALIGNMENT_CENTER;
    rightInnerThumbContainer.verticalAlignment =
      BABYLON.GUI.Control.VERTICAL_ALIGNMENT_CENTER;

    let rightPuck = makeThumbArea("rightPuck", 0, "red", "#ff23d1");
    

    rightPuck.height = "10%";
    rightPuck.width = "10%";
    rightPuck.isPointerBlocker = true;
    rightPuck.horizontalAlignment =
      BABYLON.GUI.Control.HORIZONTAL_ALIGNMENT_CENTER;
    rightPuck.verticalAlignment = BABYLON.GUI.Control.VERTICAL_ALIGNMENT_CENTER;

    rightThumbContainer.onPointerDownObservable.add(function (coordinates) {
      rightPuck.isVisible = true;
      rightPuck.floatLeft =
        adt._canvas.width -
        coordinates.x -
        rightThumbContainer._currentMeasure.width * 0.5 -
        sideJoystickOffset;
      rightPuck.left = rightPuck.floatLeft * -1;
      rightPuck.floatTop =
        adt._canvas.height -
        coordinates.y -
        rightThumbContainer._currentMeasure.height * 0.5 +
        bottomJoystickOffset;
      rightPuck.top = rightPuck.floatTop * -1;
      rightPuck.isDown = true;
      rightThumbContainer.alpha = 0.9;
    });

    rightThumbContainer.onPointerUpObservable.add(function (coordinates) {
      xAddRot = 0;
      yAddRot = 0;
      rightPuck.isDown = false;
      rightPuck.isVisible = false;
      rightThumbContainer.alpha = 0.4;
    });

    rightThumbContainer.onPointerMoveObservable.add(function (coordinates) {
      if (rightPuck.isDown) {
        xAddRot =
          adt._canvas.width -
          coordinates.x -
          rightThumbContainer._currentMeasure.width * 0.5 -
          sideJoystickOffset;
        yAddRot =
          adt._canvas.height -
          coordinates.y -
          rightThumbContainer._currentMeasure.height * 0.5 +
          bottomJoystickOffset;
        rightPuck.floatLeft = xAddRot * -1;
        rightPuck.floatTop = yAddRot * -1;
        rightPuck.left = rightPuck.floatLeft;
        rightPuck.top = rightPuck.floatTop;
      }
    });

    adt.addControl(rightThumbContainer);
    rightThumbContainer.addControl(rightInnerThumbContainer);
    rightThumbContainer.addControl(rightPuck);
    rightPuck.isVisible = false;

    camera.attachControl(canvas, true);
    let alpha = 0;
    scene.registerBeforeRender(function () {
      translateTransform = BABYLON.Vector3.TransformCoordinates(
        new BABYLON.Vector3(xAddPos / 3000, 0, yAddPos / 3000),
        BABYLON.Matrix.RotationY(camera.rotation.y)
      );
      camera.cameraDirection.addInPlace(translateTransform);
      camera.cameraRotation.y += (xAddRot / 15000) * -1;
      camera.cameraRotation.x += (yAddRot / 15000) * -1;

    });

    function makeThumbArea(name, thickness, color, background, curves, bgimage, type) {
      let rect = new BABYLON.GUI.Ellipse();
      rect.name = name;
      rect.thickness = thickness;
      rect.color = color;
      rect.background = background;
      rect.paddingLeft = type === "leftThumbContainer" ? "0px" : "0px";
      rect.paddingRight =  type === "rightThumbContainer" ? "0px" : "0px";
      rect.paddingTop = "0px";
      rect.paddingBottom = "0px";
      console.log(bgimage)
      var img = new BABYLON.GUI.Image("image", bgimage)
      img.stretch = BABYLON.GUI.Image.STRETCH_UNIFORM
      rect.addControl(img)
      return rect;
    }
  
  
    JoystickUtils.hide = () => {
      adt.removeControl(rightThumbContainer)
      adt.removeControl(leftThumbContainer)
    }
    JoystickUtils.reveal = () => {
      adt.addControl(leftThumbContainer)
      adt.addControl(rightThumbContainer)
    }
  }